import { savePrefill } from "./prefill_collect.lib";

document.querySelectorAll(".js-variant-cart-block form").forEach((form) => {
  if (!form || !(form instanceof HTMLFormElement)) return;
  form.addEventListener("submit", () => savePrefill(form));
});